import React from 'react';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export interface WithFeatureFlagsProps {
  featureFlags: ReturnType<typeof useFeatureFlag>;
}

export function withFeatureFlags<P extends object>(WrappedComponent: React.ComponentType<P & WithFeatureFlagsProps>) {
  const WithFeatureFlagsComponent = (props: P) => {
    const featureFlags = useFeatureFlag();

    return <WrappedComponent {...props} featureFlags={featureFlags} />;
  };

  WithFeatureFlagsComponent.displayName = `withFeatureFlags(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithFeatureFlagsComponent;
}
